export default __webpack_public_path__ + "static/media/bubble.3f833cb9.png";